import { Button, Checkbox, FormControlLabel, IconButton, Menu, MenuItem, Radio, RadioGroup, Select, Tab, Tabs, TextField } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import AddCommentIcon from "@mui/icons-material/AddComment";
import KeyboardCommandKeyIcon from "@mui/icons-material/KeyboardCommandKey";
import { AutoAwesome } from '@mui/icons-material';
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import HistoryIcon from '@mui/icons-material/History';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import AddIcon from '@mui/icons-material/Add';
import SwitchToggle from '../../components/SwitchToggle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import SearchBar from '../../components/SearchBar';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AddReferenceModal from '../../Modals/addReference';
import ScheduleReportModal from '../../Modals/scheduleReport';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface Report {
  title: string;
  tag: string;
  tagColor: "blue" | "green" | "purple";
}

const reports: Report[] = [
  {
    title: "UAE E-commerce Market 2024",
    tag: "uae market",
    tagColor: "blue",
  },
  {
    title: "Fashion Category Benchmark",
    tag: "category",
    tagColor: "green",
  },
  {
    title: "Internal Historical Q3 2024",
    tag: "historical",
    tagColor: "purple",
  },
];

function AIBrain() {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = React.useState("");
  const [isActive, setIsActive] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [activeIndex, setActiveIndex] = React.useState<number | null>(null);
  const open = Boolean(anchorEl);
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    index: number
  ) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setActiveIndex(index);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setActiveIndex(null);
  };

  const [value, setValue] = React.useState(0);
  const [value1, setValue1] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const handleChange1 = (event: React.SyntheticEvent, newValue: number) => {
    setValue1(newValue);
  };

  const [openIndex, setOpenIndex] = React.useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  const [openModal, setOpenModal] = React.useState(false);  
  const handleCloseModal = () => setOpenModal(false);

  const [openModal1, setOpenModal1] = React.useState(false);  
  const handleCloseModal1 = () => setOpenModal1(false);

  return (
    <>
      <div className="cards aiBrain_layout">
        <div className="aiBrain_lt_panel">
          {/* Header */}
          <div className="lt_panel_header">
            <div className="main_title">
              <h1>AI Brain</h1>
              <p>
                <button onClick={() => navigate("/dashboard")}>Dashboard</button> - AI Brain
              </p>
            </div>
            <Button
              fullWidth
              startIcon={<AddCommentIcon />}
              className='btn btn_primary'
            >
              New Chat
            </Button>
          </div>

          {/* History */}
          <div className="lt_panel_content">
            <ul className="chat_list">
              {[
                "Show me GMV growth by emirate last 6 months",
                "Which vendors are underperforming vs category average?",
                "Create a board-ready financial summary for Q2",
                "Compare our conversion rates to UAE benchmarks",
              ].map((text, index) => (
                <li key={index} className={index === 0 ? "active" : ""}>
                  <p>{text}</p>

                  <IconButton
                    size="small"
                    className="more-btn"
                    aria-controls={open ? "chat-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={(e) => handleClick(e, index)}
                  >
                    <MoreHorizOutlinedIcon />
                  </IconButton>
                  <Menu
                    id="chat-menu"
                    className='menu-'
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    disablePortal
                    disableScrollLock
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <MenuItem onClick={handleClose}>
                      <BookmarkBorderIcon fontSize="small" /> Save Query
                    </MenuItem>
                    <MenuItem onClick={handleClose} className="c_danger">
                      <DeleteOutlineIcon fontSize="small" /> Delete
                    </MenuItem>
                  </Menu>
                </li>
              ))}

            </ul>

            {/* <div className="empty_state">
              <HistoryIcon className="icon" />
              <p>No conversations yet</p>
            </div> */}
          </div>

          {/* Footer */}
          <div className="lt_panel_footer">
            <KeyboardCommandKeyIcon fontSize="small" />
            <span>Press</span>
            <kbd>Ctrl + K</kbd>
            <span>for quick access</span>
          </div>
        </div>

        <div className="aiBrain_main_panel">
          {/* Top Bar */}
          <div className="aiBrain_main_header">
            <div className="title">
              <AutoAwesome className="brand-icon" />
              <div>
                <h2>Ask Bouteek</h2>
                <p>Owner AI Console</p>
              </div>
            </div>

            <IconButton onClick={() => setIsActive(!isActive)}>
              {isActive ? <CloseFullscreenIcon /> : <OpenInFullOutlinedIcon />}
            </IconButton>
          </div>

          <div className={`aiBrain_main_body ${isActive ? "" : "has_aside"}`}>
            <div className="body_lt">
              <div className="inner">
                {/* HEADER */}
                <div className="ask-header">
                  <div className="header-top">
                    <div className="title">
                      <span className="icon"><AutoAwesome /></span>
                      <h2>Ask Bouteek</h2>
                    </div>

                    <button type="button" className="link-btn"><AutorenewOutlinedIcon /> New Chat</button>
                  </div>

                  <div className="form">
                    <Select
                      fullWidth
                      hiddenLabel
                      defaultValue={'10'}
                    >
                      <MenuItem value={10}>Insights</MenuItem>
                      <MenuItem value={20}>Report</MenuItem>
                      <MenuItem value={30}>Benchmark</MenuItem>
                      <MenuItem value={40}>Data Only</MenuItem>
                    </Select>

                    <Select
                      fullWidth
                      hiddenLabel
                      defaultValue={'10'}
                    >
                      <MenuItem value={10}>Marketplace</MenuItem>
                      <MenuItem value={20}>Category</MenuItem>
                      <MenuItem value={30}>Vendor</MenuItem>
                      <MenuItem value={40}>Region</MenuItem>
                      <MenuItem value={50}>Campaign</MenuItem>
                    </Select>

                    <Select
                      fullWidth
                      hiddenLabel
                      defaultValue={'10'}
                    >
                      <MenuItem value={10}>Last 7 days</MenuItem>
                      <MenuItem value={20}>Last 30 days</MenuItem>
                      <MenuItem value={30}>Last 90 days</MenuItem>
                      <MenuItem value={40}>This Month</MenuItem>
                      <MenuItem value={50}>Last Month</MenuItem>
                      <MenuItem value={60}>This Quarter</MenuItem>
                      <MenuItem value={70}>Last Quarter</MenuItem>
                    </Select>

                    <div className="status-badge">
                      <span className="dot" />
                      Data current
                    </div>
                  </div>
                </div>

                {/* BODY */}
                <div className="ask-body">
                  <div className="welcome">
                    <div className="welcome-icon"><AutoAwesome /></div>

                    <h3>Welcome to Ask Bouteek</h3>

                    <p>
                      Ask anything about your business data. I can analyze sales,
                      compare benchmarks, generate reports, and provide insights.
                    </p>

                    <div className="suggestions">
                      <button type="button">
                        Show me GMV growth by emirate last 6 months
                      </button>

                      <button type="button">
                        Which vendors are underperforming vs category average?
                      </button>

                      <button type="button">
                        Create a board-ready financial summary for Q2
                      </button>

                      <button type="button">
                        Compare our conversion rates to UAE benchmarks
                      </button>
                    </div>
                  </div>
                </div>

                {/* FOOTER */}
                <form className="ask-footer form">
                  <TextField fullWidth hiddenLabel placeholder='Ask anything about your business...' />
                  <IconButton><SendOutlinedIcon style={{ transform: "rotate(-45deg)" }} /></IconButton>
                </form>
              </div>
            </div>
            <div className="body_rt">
              <div className="border_card">
                <div className="card_head">
                  <h2 className='flex'>
                    <StorageOutlinedIcon className='c_blue' />
                    Data Sources
                    <span className='badge'>11 enabled</span>
                  </h2>
                </div>
                <div className="card_body">
                  <div className="data_list">
                    <SwitchToggle label={
                      <>
                        <span className="badge green">Revenue</span>
                        <Tooltip title="Revenue"><InfoOutlinedIcon /></Tooltip>
                      </>
                    } />
                    <SwitchToggle label={
                      <>
                        <span className="badge blue">Operations</span>
                        <Tooltip title="Operations"><InfoOutlinedIcon /></Tooltip>
                      </>
                    } />
                    <SwitchToggle label={
                      <>
                        <span className="badge amber">Finance</span>
                        <Tooltip title="Finance"><InfoOutlinedIcon /></Tooltip>
                      </>
                    } />
                    <SwitchToggle label={
                      <>
                        <span className="badge purple">Vendors</span>
                        <Tooltip title="Vendors"><InfoOutlinedIcon /></Tooltip>
                      </>
                    } />
                    <SwitchToggle label={
                      <>
                        <span className="badge pink">Customers</span>
                        <Tooltip title="Customers"><InfoOutlinedIcon /></Tooltip>
                      </>
                    } />
                    <SwitchToggle label={
                      <>
                        <span className="badge red">Support</span>
                        <Tooltip title="Support"><InfoOutlinedIcon /></Tooltip>
                      </>
                    } />
                    <SwitchToggle label={
                      <>
                        <span className="badge cyan">Marketing</span>
                        <Tooltip title="Marketing"><InfoOutlinedIcon /></Tooltip>
                      </>
                    } />
                    <SwitchToggle label={
                      <>
                        <span className="badge indigo">AI</span>
                        <Tooltip title="AI"><InfoOutlinedIcon /></Tooltip>
                      </>
                    } />
                  </div>
                </div>
              </div>
              <div className="border_card">
                <div className="card_head">
                  <h2 className='flex'>
                    <TrackChangesIcon className='c_green' />
                    References
                    <Button className='btn btn_success sm' onClick={() => setOpenModal(true)}><AddIcon /> Add</Button>
                  </h2>
                </div>
                <div className="card_body reference_body">
                  <div className="reports-wrapper">
                    {reports.map((report, index) => (
                      <div className="report-card" key={index}>
                        {/* Header */}
                        <div
                          className="card-header"
                          onClick={() => handleToggle(index)}
                        >
                          <div className="left">
                            <span
                              className={`chevron ${openIndex === index ? "open" : ""
                                }`}
                            >
                              ›
                            </span>

                            <div className="content">
                              <p className="title">{report.title}</p>
                              <div className="tags">
                                <span className={`tag ${report.tagColor}`}>
                                  {report.tag}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Details */}
                        {openIndex === index && (
                          <div className="report-details">
                            <div className="info-grid">
                              <div className="info-block">
                                <p className="label">URL</p>
                                <p className="value">
                                  https://bouteekadmindesign.appgrowthcompany.com/
                                </p>
                              </div>
                            </div>

                            <div className="section">
                              <p className="label">Categories</p>
                              <div className="category-tags">
                                <span className="tag">fashion</span>
                                <span className="tag">electronics</span>
                                <span className="tag">home</span>
                              </div>
                            </div>

                            <div className="section">
                              <p className="label">KPIs</p>
                              <div className="kpi-grid">
                                <div className="kpi-item">
                                  <span>aov</span>
                                  <strong>380</strong>
                                </div>
                                <div className="kpi-item">
                                  <span>return rate</span>
                                  <strong>12</strong>
                                </div>
                                <div className="kpi-item">
                                  <span>conversion rate</span>
                                  <strong>2.8</strong>
                                </div>
                                <div className="kpi-item">
                                  <span>cart abandonment</span>
                                  <strong>68</strong>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="border_card">
                <div className="card_head custom_tabs2">
                  <h2 className='flex'>
                    <DescriptionOutlinedIcon className='c_blue' />
                    Reports & Export
                  </h2>
                  <Tabs className='custom_tabs_links' value={value1} onChange={handleChange1} aria-label="basic tabs example">
                    <Tab label="Generate" {...a11yProps(0)} />
                    <Tab label="History" {...a11yProps(1)} />
                    <Tab label="Scheduled" {...a11yProps(2)} />
                  </Tabs>
                </div>
                <div className="card_body report_card">
                  <CustomTabPanel value={value1} index={0}>
                    <div className="form">
                      <div className="gap_p">
                        <div className="w_100">
                          <label htmlFor="report-title">Report Title</label>
                          <TextField fullWidth hiddenLabel placeholder='' inputProps={{ id: "report-title" }} />
                        </div>
                        <div className="w_100">
                          <label htmlFor="">Include Sections</label>
                          <div className="checkbox_list">
                            <FormControlLabel control={<Checkbox />} label="Executive Summary" />
                            <FormControlLabel control={<Checkbox />} label="Key Metrics" />
                            <FormControlLabel control={<Checkbox />} label="Visualizations" />
                            <FormControlLabel control={<Checkbox />} label="AI Insights" />
                            <FormControlLabel control={<Checkbox />} label="Recommendations" />
                            <FormControlLabel control={<Checkbox />} label="Raw Data Tables" />
                          </div>
                        </div>
                        <div className="w_100">
                          <label htmlFor="">Export Format</label>
                          <RadioGroup
                            className="checkbox_type_btn"
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="PDF"
                            name="radio-buttons-group"
                          >
                            <FormControlLabel value="PDF" control={<Radio />} label={<><DescriptionOutlinedIcon /> PDF</>} />
                            <FormControlLabel value="Excel" control={<Radio />} label={<><DescriptionOutlinedIcon /> Excel</>} />
                            <FormControlLabel value="CSV" control={<Radio />} label={<><DescriptionOutlinedIcon /> CSV</>} />
                          </RadioGroup>
                        </div>
                        <div className="w_100">
                          <label htmlFor="">Branding</label>
                          <div className="gap_p">
                            <div className="w_50">
                              <label htmlFor="branding-color" className='sm'>Primary Color</label>
                              <TextField fullWidth hiddenLabel placeholder='' type='color' inputProps={{ id: "branding-color" }} />
                            </div>
                            <div className="w_50">
                              <label htmlFor="branding-footer" className='sm'>Footer Text</label>
                              <TextField fullWidth hiddenLabel placeholder='' inputProps={{ id: "branding-footer" }} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form_btn">
                        <Button className='btn btn_primary w_100'><FileDownloadOutlinedIcon /> Generate Report</Button>
                      </div>
                    </div>
                  </CustomTabPanel>
                  <CustomTabPanel value={value1} index={1}>
                    <div className="empty_state">
                      <DescriptionOutlinedIcon className="icon size_bg" />
                      <p>No reports generated yet</p>
                    </div>
                  </CustomTabPanel>
                  <CustomTabPanel value={value1} index={2}>
                    <Button className='btn btn_bordered' onClick={() => setOpenModal1(true)}><AddIcon /> Schedule New Report</Button>
                    <div className="empty_state">
                      <CalendarTodayOutlinedIcon className="icon size_bg" />
                      <p>No scheduled reports</p>
                    </div>
                  </CustomTabPanel>
                </div>
              </div>
              <div className="border_card">
                <div className="card_head">
                  <h2 className='flex'>
                    <BookmarkBorderOutlinedIcon className='c_orange' />
                    Saved Queries & Playbooks
                  </h2>
                </div>
                <div className="card_body queries_card">
                  <SearchBar
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setSearchTerm}
                    placeholder="Search queries..."
                  />

                  <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="All (0)" {...a11yProps(0)} />
                    <Tab label={<><BusinessCenterOutlinedIcon /> Board</>} {...a11yProps(1)} />
                    <Tab label={<><GroupOutlinedIcon /> Investors</>} {...a11yProps(2)} />
                    <Tab label={<><AttachMoneyOutlinedIcon /> Finance</>} {...a11yProps(3)} />
                    <Tab label={<><SettingsOutlinedIcon /> Operations</>} {...a11yProps(4)} />
                    <Tab label={<><FolderOpenOutlinedIcon /> General</>} {...a11yProps(5)} />
                  </Tabs>
                  <CustomTabPanel value={value} index={0}>
                    <div className="empty_state">
                      <BookmarkBorderOutlinedIcon className="icon size_bg" />
                      <p>No saved queries yet</p>
                      <p><small>Save queries from chat to access them here</small></p>
                    </div>
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={1}>
                    <div className="empty_state">
                      <BookmarkBorderOutlinedIcon className="icon size_bg" />
                      <p>No saved queries yet</p>
                      <p><small>Save queries from chat to access them here</small></p>
                    </div>
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={2}>
                    <div className="empty_state">
                      <BookmarkBorderOutlinedIcon className="icon size_bg" />
                      <p>No saved queries yet</p>
                      <p><small>Save queries from chat to access them here</small></p>
                    </div>
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={3}>
                    <div className="empty_state">
                      <BookmarkBorderOutlinedIcon className="icon size_bg" />
                      <p>No saved queries yet</p>
                      <p><small>Save queries from chat to access them here</small></p>
                    </div>
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={4}>
                    <div className="empty_state">
                      <BookmarkBorderOutlinedIcon className="icon size_bg" />
                      <p>No saved queries yet</p>
                      <p><small>Save queries from chat to access them here</small></p>
                    </div>
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={5}>
                    <div className="empty_state">
                      <BookmarkBorderOutlinedIcon className="icon size_bg" />
                      <p>No saved queries yet</p>
                      <p><small>Save queries from chat to access them here</small></p>
                    </div>
                  </CustomTabPanel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddReferenceModal open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
      <ScheduleReportModal open={openModal1} onClose={handleCloseModal1} setOpen={setOpenModal1} />
    </>
  )
}

export default AIBrain